import * as _ from "lodash";
import { Node } from "../Node";
import { AbstractProperty } from "./AbstractProperty";

export class PString extends AbstractProperty<string, Node> {
  default: string;

  constructor(args) {
    super({
      type: "String",
      default: null,
      ...args,
    });
  }

  typeCheck(value) {
    return _.isString(value);
  }
}
